import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.937 6.033a.7.7 0 0 0-.993-.987l-.77.774-.28-.282a.7.7 0 1 0-.993.988l.777.78a.7.7 0 0 0 .992 0zm1.589-.463a.7.7 0 1 0 0 1.4h7.076a.7.7 0 1 0 0-1.4zm0 3.735a.7.7 0 1 0 0 1.4h7.076a.7.7 0 1 0 0-1.4zm0 3.736a.7.7 0 1 0 0 1.4h7.076a.7.7 0 1 0 0-1.4zM6.937 9.869a.7.7 0 0 0-.993-.988l-.77.775-.28-.282a.7.7 0 0 0-.993.988l.777.78a.7.7 0 0 0 .992 0zm-.003 2.822a.7.7 0 0 1 .003.99L5.67 14.955a.7.7 0 0 1-.992 0l-.777-.781a.7.7 0 1 1 .993-.987l.28.281.77-.774a.7.7 0 0 1 .99-.003",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ChecklistIcon20.js.map